import { AddIconHome, IconAds, IconFunnel, IconPlusCircle } from "../assets/icons/icons";
import { dictionary, Language } from "../utils/dictionary";

export const quickActions = (language: Language) => [
    {
        title: dictionary["create-new-funnel"][language],
        icon: (active: boolean) => (
            <IconPlusCircle color={active ? "#ffffff" : "#6A6A6A"} width="30px" height="30px" />
        ),
        path: "/onboarding",
    },
    {
        title: dictionary["create-new-home"][language],
        icon: (active: boolean) => (
            <AddIconHome color={active ? "#ffffff" : "#6A6A6A"} width="35px" height="35px" />
        ),
        path: "/onboarding/home",
    },
    {
        title: dictionary["see-my-funnels"][language],
        icon: (active: boolean) => (
            <IconFunnel color={active ? "#ffffff" : "#6A6A6A"} width={"30px"} height={"30px"} />
        ),
        path: "/funnels",
    },
    {
        title: dictionary["see-my-ads"][language],
        icon: (active: boolean) => (
            <IconAds color={active ? "#ffffff" : "#6A6A6A"} width={"30px"} height={"30px"} />
        ),
        path: "/ads",
    },
];